export default __webpack_public_path__ + "static/media/queens.0e7fef5c.jpg";